<template>
  <div
    class="explorer-controls">
    <label
      class="label medium-wide-size margin-left-m explorer-label hide-on-mobile">
      {{ $t('health.explorer.groupSelector') }}
    </label>
    <div class="filter">
      <treeselect
        class="small-wide-size margin-left-l small-width-size"
        :clearable="false"
        :hidden="false"
        :multiple="false"
        :options="options"
      v-model="internalSelectedGroup"
      />
    </div>
    <btn-pill
      class="margin-left-l"
      :btnText="$t('health.explorer.show')"
      btn-size="xs"
      v-on:click="$emit('click')"/>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import BtnPill from '@/components/shared/buttons/BtnPill';

export default {
  name: 'HealthExplorerControlsGroupSelect',
  components: {
    BtnPill,
    Treeselect
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    internalSelectedGroup: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

.explorer-controls {
  display: flex;
  align-items: center;
}

.small-width-size {
  width: 10rem;
}

.label {
  font-size: 0.675rem;
  margin-right: $sp-margin-smaller;
  @media (max-width: $screen-l-max) {
    display: block;
    margin-bottom: $sp-margin-smaller;
  }
}

.filter {
  @media (max-width: $screen-l-max) {
    width: 100%;
    margin-bottom: $sp;
  }
}

.hide-on-mobile {
  @media (max-width: $screen-xl) {
    visibility: hidden;
  }
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/explorer/HealthExplorerControlsGroupSelect.vue